import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const formActionUrl = 'https://readdy.ai/api/form/d9tgejn8l97n3eas39m0';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    setErrorMessage('');

    try {
      const formData = new FormData(form);
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value.toString());
      });

      const res = await fetch(formActionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
      });

      const responseText = await res.text();
      let parsed: any = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore
      }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg =
          parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        if (typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam')) {
          setStatus('error');
          setErrorMessage('提交失败，请稍后重试');
        } else {
          setStatus('error');
          setErrorMessage(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试');
        }
      }
    } catch {
      setStatus('error');
      setErrorMessage('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-2xl mx-auto text-center">
        <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
          订阅更新
        </span>
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
          让幸福，每周如约而至
        </h2>
        <p className="text-sm text-foreground-600 mb-8">
          订阅我们的Newsletter，每周获取最新的亲密关系知识和实用技巧，让关系更加美满。
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form="true"
          id="newsletter-form"
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-secondary-600">订阅成功！感谢你的关注，我们会定期为你推送优质内容。</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-red-500">{errorMessage}</p>
        )}

        <p className="mt-4 text-xs text-foreground-400">
          我们尊重你的隐私，绝不会发送垃圾邮件，也绝不会分享你的邮箱给第三方。
        </p>
      </div>
    </section>
  );
}